import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../assets/i18n";
import "./BoxTagPage.scss";
import { ButtonStandard, TagMarker, HeaderActions, FooterActions, ToastMessage, CheckBox } from "../../components";
import ItemList from "../../containers/ItemList/ItemList";
import getMessageError from "../../utils/getMessageError";
import { Creators as actionTag } from "../../store/ducks/tag";
import { Creators as actionPrinter } from "../../store/ducks/printer";
import { TAGTYPES } from '../../utils/constants';

function BoxTagPage(props) {
    
    const dispatch = useDispatch();
    const lang = useSelector(state => state.language.name);
    const itemList = useSelector(state => state.itemList.itemsBox);
    const orderList = useSelector(state => state.orderList);
    const tag = useSelector(state => state.tag);
    const printer = useSelector(state => state.printer);

    const tagToast = useSelector(state => state.tag.tagToast);
    
    const [seloMultipack, setSeloMultipack] = useState(false);
    const [showMultipackCheckbox, setShowMultipackCheckbox] = useState(false);
    const [arrChecked, setArrChecked] = useState([]);
    const [option, setOption] = useState('download');
    const [tipoSelo, setTipoSelo] = useState(TAGTYPES.ZEBRA.NAME);
    const [objQtVolume, setObjQtVolume] = useState([]);
    const [invalidVolume, setInvalidVolume] = useState(false);
    const [showTipoSelo, setShowTipoSelo] = useState(false);
    const [validateDownload, setValidateDownload] = useState({
        validated: false,
        tipoTag: '',
        tipoDeRetorno: '',
        itens: '',
        pedido: '',
        modelo: ''
    });
 
    const [showToast,    setShowToast]    = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');
    //const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {	
        setShowToast(tagToast.showToast)
        setToastMessage(tagToast.message)
        setMessageType(tagToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tagToast]);

    useEffect(() => {
        if(orderList[0] !== undefined){
            dispatch({ 
                type: 'GET_ITEMS_BOX', 
                pedido: orderList[0].id
            })

            if (orderList[0].empresa.nome !== 'Renner') {
                setShowTipoSelo(false)
            } else {
                setShowTipoSelo(true)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, orderList])

    useEffect(() => {
        let objQtVolume = {};
        if(itemList.length) {
            for (let i = 0; i < itemList.length; i++) {
                objQtVolume[itemList[i].id] = {
                    qtVolume: itemList[i].qtVolume,
                    qtVolumeMax: itemList[i].qtVolume,
                }

                if (itemList[i].packNo && itemList[i].tamPacoteSupp && itemList[i].tamPacoteSupp > 1) {
                    setShowMultipackCheckbox(true)
                }
            }
        }
        setObjQtVolume(objQtVolume);
        setArrChecked(toggleAllArrChecked(itemList, arrChecked));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemList])

    useEffect(() => {
        dispatch(actionTag.tagsClean());
        dispatch(actionPrinter.printerWriteClean());
    }, [dispatch])

    useEffect(() => {
        if (tag.error) {
            setShowToast(true)
            setToastMessage(messages[lang].messagesCode[getMessageError(tag.error)])
            dispatch(actionTag.tagsClean());
        }
    }, [tag, lang, dispatch])

    useEffect(() => {
        if (printer.error) {
            setShowToast(true)
            setToastMessage(messages[lang].messagesCode[getMessageError(printer.error)])
            dispatch(actionPrinter.printerWriteClean());
        }
    }, [printer.error, lang, dispatch])

    useEffect(() => {
        if (validateDownload.validated) {

            let { pedido, tipoTag, tipoDeRetorno, itens } = validateDownload

            setValidateDownload({
                validated: false,
                tipoTag: '',
                tipoDeRetorno: '',
                itens: '',
                pedido: ''
            })

            if (invalidVolume) {
                setInvalidVolume(false)
                setShowToast(true)
                setToastMessage(messages[lang].boxTagVolumeWarning)
            } else {
                setShowToast(false)
                setToastMessage('')
                dispatch({
                    type: "GET_TAG",
                    payload: {
                        tipoTag: tipoTag,
                        tipoDeRetorno: tipoDeRetorno,
                        pedido: pedido,
                        itens: itens,
                        nomeArquivo: messages[lang].stamps,
                        multipack: seloMultipack,
                        tipoSelo: tipoSelo,
                        modelo: 'modelo_padrao'
                    }
                })
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateDownload])

   // const handleCheck = (e) => {
     //   setIsChecked(e.target.checked);
      //};

    const marcarSeloMultipack = (marcarMultipack, itens) => {
        setSeloMultipack(marcarMultipack)

        let elements = document.getElementsByClassName("qtVolumeItem");
        let newObj = {}

        for(var i = 0; i < elements.length; i++) {
            // eslint-disable-next-line no-loop-func
            let itemIndex = itens.findIndex(function(item) {
                return item.idItem === elements[i].id.replace('volumeItem_', '');
            });

            if (itemIndex >= 0) {
                if (marcarMultipack) {
                    let volumeBackup = objQtVolume[itens[itemIndex].idItem].qtVolume
                    newObj[itens[itemIndex].idItem] = {
                        qtVolume: itens[itemIndex].allowedVolumeMultipack.volumeDefault,
                        qtVolumeMax: objQtVolume[itens[itemIndex].idItem].qtVolumeMax,
                        volumeBackup: volumeBackup
                    }
                } else {
                    newObj[itens[itemIndex].idItem] = {
                        qtVolume: objQtVolume[itens[itemIndex].idItem].volumeBackup,
                        qtVolumeMax: objQtVolume[itens[itemIndex].idItem].qtVolumeMax,                        
                    }
                }
            }
        }

        setObjQtVolume(newObj)
    }

    const getTag = (tipoTag, tipoDeRetorno, pedido, itens, tipoSelo) => {
        let elements = document.getElementsByClassName("qtVolumeItem");

        for(var i = 0; i < elements.length; i++) {
            // eslint-disable-next-line no-loop-func
            let itemIndex = itens.findIndex(function(item) {
                return item.idItem === elements[i].id.replace('volumeItem_', '');
            });

            if (itemIndex >= 0) {
                let volumeData = itens[itemIndex].canUseMultiPack && seloMultipack ? itens[itemIndex].allowedVolumeMultipack : itens[itemIndex].allowedVolume
                let { volumeMin, volumeMax } = volumeData

                if (elements[i].value < volumeMin || elements[i].value > volumeMax) {                
                    document.getElementById(elements[i].id).classList.add('validation-error');
                    setInvalidVolume(true)
                } else {
                    document.getElementById(elements[i].id).classList.remove('validation-error');
                }    
            }

            if (i === elements.length - 1) {
                setValidateDownload({
                    validated: true,
                    tipoTag: tipoTag,
                    tipoDeRetorno: tipoDeRetorno,
                    itens: itens,
                    pedido: pedido,
                    tipoSelo: tipoSelo,
                    modelo: 'modelo_padrao'
                })
            }
        }
    }

    const toggleAllArrChecked = (listItems, checkboxArr) => (
        checkboxArr && listItems && checkboxArr.length < listItems.length ? listItems.map(item => item.id) : []
    )

    const handleAllArrChecked = () => {
        setArrChecked(toggleAllArrChecked(itemList, arrChecked));
    }

    const checkVolume = (item, useMultipack) => {
        // 5% de tolerância pra mais ou pra menos

        var allowedExtraValue
        var volumeDefault
        var volumeMin
        var volumeMax

        if (useMultipack && item.packNo && item.tamPacoteSupp && item.tamPacoteSupp > 1) {
            let volumeMultipack = (item.qtCompra / item.qtItens)  
            volumeDefault = (item.qtCompra / item.qtItens)          

            allowedExtraValue = ((volumeMultipack * 5)/100) | 0

            volumeMin = parseInt(volumeMultipack - allowedExtraValue)
            volumeMax = parseInt(volumeMultipack + allowedExtraValue)
        } else {
            allowedExtraValue = ((item.qtVolume * 5)/100) | 0
            volumeDefault = (item.qtVolume) 

            volumeMin = parseInt(item.qtVolume - allowedExtraValue)
            volumeMax = parseInt(item.qtVolume + allowedExtraValue)
        }
        
        return { 
            volumeDefault: volumeDefault,
            volumeMin: volumeMin, 
            volumeMax: volumeMax
        }
    }

    const checkMultipack = (item) => {
        // 5% de tolerância pra mais ou pra menos

        if (item.packNo && item.tamPacoteSupp && item.tamPacoteSupp > 1) {
            return true
        }

        return false
    }

    const onChangeInputValue = idItem => event => {
        let newValue = event.target.value.replace(/[^0-9]+/g, "");
        newValue = newValue && parseInt( newValue , 10);
        setObjQtVolume({
            ...objQtVolume, 
            [idItem]: {
                qtVolume: newValue,
                qtVolumeMax: objQtVolume[idItem].qtVolumeMax,
            }
        });
    }

    const getObjQtVolume = idValue => (
        objQtVolume && objQtVolume[idValue] ? objQtVolume[idValue].qtVolume : ''
    )

    const outputOptionHandler = (optionChecked) => {
        optionChecked === '0'
            ? setOption('download') 
            : optionChecked === '1'
                ? setOption('print')
                : setOption('generatePDF');
    }

    const listSelectedItems = () => {
        return arrChecked.map(idChecked => {
            const itemSelected = itemList.find(item => item.id === idChecked);
            if (itemSelected) {
                return {
                    idItem: itemSelected.id,
                    qtItem: getObjQtVolume(itemSelected.id),
                    allowedVolume: checkVolume(itemSelected, false),
                    canUseMultiPack: checkMultipack(itemSelected),
                    allowedVolumeMultipack: checkVolume(itemSelected, true),
                };
            } else {
                return {};
            }
        });
    }

    const pageBack = () => {
        dispatch({ type: "ITEM_CLEAN" })
		props.history.push(`/main`);
    };

    const dileAction = arrSelection => arrSelection.length <= 0;

    const buttonAction = () => (
        <ButtonStandard
            id="box-tag-label_button"
            text={messages[lang][option]}
            disabled={dileAction(arrChecked)}
            textClass="text-2"
            className="btn btn-primary px-3 py-2 btn-light"
            onClick={() => getTag("gerarSeloCaixa", option, orderList[0].id, listSelectedItems(), tipoSelo)}
            isLoading={tag.loading}
        />
    )
    
    const headers = [
        {
            checkbox: {
                arrChecked: arrChecked,
                handleAllArrChecked: handleAllArrChecked,
            }
        },
        messages[lang].labelItem,
        messages[lang].labelPackNo,
        messages[lang].product,
        messages[lang].labelTotalItems,
        messages[lang].totalStamps,
    ];
    
    const listItemsTable = !(itemList && itemList.length > 0) ? [[]] : 
        itemList.map(value => {
            return ([
            {
                checkbox: {
                    id: value.id,
                    arrChecked: arrChecked,
                    setArrChecked: setArrChecked,
                }
            },
            value.codItem,
            value.packNo || '-',
            {
                text: value.detalheItems && value.detalheItems[0] ? value.detalheItems[0].descricaoCurta : '',
                maxLength: 300,
                tooltip: value.detalheItems && value.detalheItems[0] ? value.detalheItems[0].descricaoCurta : '',
            },
            value.qtCompra,
            {
                text: <input id={`volumeItem_${value.id}`} size={15} className="qtVolumeItem"
                        onChange={onChangeInputValue(value.id)}
                        value={getObjQtVolume(value.id)} />
            }
        ])}
    );

    const boxTagOptions = [
        { id: TAGTYPES.ZEBRA.NAME, message: TAGTYPES.ZEBRA.NAME },
        { id: TAGTYPES.TXT.NAME, message: TAGTYPES.TXT.NAME },
    ];

    return (  
        <div className="box-tag-page">
            <iframe title="myFrame" id="ifmcontentstoprint" style={{height: 0, width: 0, position: "absolute"}}></iframe>
            <ToastMessage show={showToast} setShow={setShowToast} message={toastMessage} />

            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={toastMessage} 
                toastClass={messageType} />

            <HeaderActions
                pageBack={pageBack} 
                titlePage={messages[lang].boxTag}
            />

            <Container className="mt-2">
                <Row className="justify-content-center">
                    <Col>
                        <TagMarker
                            onClick={outputOptionHandler}
                            enableDownload
                            enablePrint
                        />
                    </Col>

                    {
                        showMultipackCheckbox
                        ?
                        <Col>
                        <Container className="py-1">
                            <Row className="justify-content-center">
                                <p className="text-3 text-color-black font-weight-bolder my-0 pt-1">
                                    {messages[lang].seloMultipack}
                                </p>
                            </Row>
                        </Container>
                        <Container className="py-2 px-2 justify-content-between">
                            <CheckBox 
                                clicked={seloMultipack} 
                                onClick={() => marcarSeloMultipack(!seloMultipack, listSelectedItems())}
                            />                        
                        </Container>
                        </Col>
                        :
                        null
                    }

                    {
                        showTipoSelo
                        ?
                        <Col>
                            <Container className="py-1">
                                <Row className="justify-content-center">
                                    <p className="text-3 text-color-black font-weight-bolder my-0 pt-1">
                                        {messages[lang].boxTagTypes}
                                    </p>
                                </Row>
                            </Container>

                            <Form.Control
                                as="select"
                                className="text-2 border-radius-full"
                                type="text"
                                value={tipoSelo || ''}
                                disabled={false}
                                onChange={event => setTipoSelo(event.target.value)}
                            >
                                {
                                    boxTagOptions.map(value => (
                                        <option key={value.message} value={value.id}>{value.message}</option>
                                    ))
                                }
                            </Form.Control>
                        </Col>
                        :
                        null
                    }
                </Row>
            </Container>

            <Container className="mt-2 pt-3 mb-5 pb-5">
                <ItemList titleTable={messages[lang].boxTag} header={headers} listTable={listItemsTable} />
            </Container>

            <FooterActions ButtonGroupRight={buttonAction} />

        </div>
    )
}

export default withRouter(BoxTagPage); 